<script lang="ts">
    import { onDestroy, onMount } from "svelte";
    import FavoriteTranslationMarker from "./FavoriteTranslationMarker.svelte";

    let translationItems: {
        favoriteMarker: HTMLButtonElement;
        phrase: string;
    }[] = [];
    function updateMarkers() {
        translationItems = Array.from(
            document.querySelectorAll<HTMLElement>(".translation__item")
        )
            .map((translationElement) => ({
                translationElement,
                phrase: translationElement
                    .querySelector<HTMLElement>(".translation__item__pharse")?.textContent.trim(),
                favoriteMarker:
                    translationElement.querySelector<HTMLButtonElement>(
                        ".add-to-favorite"
                    ),
            }))
            .filter((item) => item.favoriteMarker);
    }

    onMount(() => {
        document.addEventListener("glosbe.newTranslationsLoaded", updateMarkers);
        updateMarkers();
    });

    onDestroy(() => {
        document.removeEventListener(
            "glosbe.newTranslationsLoaded",
            updateMarkers
        );
    });
    $: {
        translationItems.forEach(translationItem => {
            const marker = translationItem.favoriteMarker;
            const MARKER_INITIALIZED_DATA_PROPERTY_NAME = "markerInitialized";
            if (marker.dataset[MARKER_INITIALIZED_DATA_PROPERTY_NAME]) {
                return;
            }
            const menuContainer = document.createElement("div");
            marker.parentElement.insertBefore(menuContainer, marker.nextElementSibling);
            new FavoriteTranslationMarker({
                target: menuContainer,
                props: {
                    marker: marker,
                    phrase: translationItem.phrase
                }
            })
            marker.dataset[MARKER_INITIALIZED_DATA_PROPERTY_NAME] = "true";
        });
    }
</script>
